'use strict';
const _ = require('underscore'),
	fontParser = require('@mindmup/mapjs-core/src/theme/font-parser'),
	initDummyBox = function () {
		const box = document.createElement('div');
		box.style.position = 'absolute';
		box.style.visibility = 'hidden';
		return box;
	},
	dummyTextBox = initDummyBox(),
	//TODO: test if we can leave this in the body with z-index that hides it
	calcBounds = function (title, maxWidth, fontInfo) {
		document.querySelector('body').appendChild(dummyTextBox);
		dummyTextBox.style.font = fontParser(fontInfo);
		dummyTextBox.style.maxWidth = maxWidth ? `${maxWidth}px` : '';
		if (maxWidth && (maxWidth > window.innerWidth)) {
			dummyTextBox.style.minWidth = `${maxWidth}px`;
		} else {
			dummyTextBox.style.minWidth = '';
		}
		dummyTextBox.innerText = title;
		let bounds = dummyTextBox.getBoundingClientRect();
		const scrollWidth = dummyTextBox.scrollWidth,
			needsReflow = scrollWidth > bounds.width;

		if (needsReflow) {
			dummyTextBox.style.maxWidth = `${scrollWidth}px`;
			bounds = dummyTextBox.getBoundingClientRect();
		}
		dummyTextBox.remove();
		return {
			width: Math.ceil(bounds.width),
			height: Math.ceil(bounds.height)
		};
	},
	calcHash = function (title, maxWidth, fontInfo) {
		const fontLoaded = document.fonts.check(fontParser(fontInfo));
		return JSON.stringify({title: title, maxWidth: maxWidth, fontInfo: fontInfo, fontLoaded: fontLoaded});
	},
	textSizer = _.memoize(calcBounds, calcHash);
module.exports = textSizer;
